import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentMethodPendingMessage_charge$key } from './__generated__/PaymentMethodPendingMessage_charge.graphql.ts';

type PaymentMethodPendingMessageProps = {
  charge: PaymentMethodPendingMessage_charge$key;
};

const PaymentMethodPendingMessage = (
  props: PaymentMethodPendingMessageProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentMethodPendingMessage_charge$key>(
    graphql`
      fragment PaymentMethodPendingMessage_charge on Charge {
        company {
          nameFriendly
        }
        value
      }
    `,
    props.charge,
  );

  if (!charge?.value) {
    return (
      <Typography variant='h5' fontWeight='bold' textAlign='center'>
        {t('Choose how to pay {{companyName}}', {
          companyName: charge?.company?.nameFriendly,
        })}
      </Typography>
    );
  }

  return (
    <Typography variant='h5' fontWeight='bold' textAlign='center'>
      {t('Choose how to pay {{value}} to {{companyName}}', {
        value: convertToMoney(charge.value),
        companyName: charge?.company?.nameFriendly,
      })}
    </Typography>
  );
};

export default PaymentMethodPendingMessage;
